import Vue from 'vue'
import Component from 'vue-class-component'
import { cloneDeep, tap, set } from 'lodash'

@Component
export default class ChildComponentMixin extends Vue {
    public update(object: object, key: string, value: any) {
        this.$emit(
            'input',
            tap(cloneDeep(object), (v) => set(v, key, value)),
        )
    }
}
